import React from 'react'
import { useSelector } from "react-redux";
import style from 'styled-components';
import Container from '../components/Layout/Container/index';
import Title from '../components/Layout/Title';
import Format from '../components/Layout/Format/index'


const Body = style.div`
  display:flex;
  flex-direction:column;
  border:1px solid black;
  box-shadow:box-shadow:1px 1px 5px black;
`;

const Info = style.div`
   display:flex;
   flex-direction:column;
   gap:0.5rem;
   background:lightgray;
   padding:2.0rem;
`
const Span = style.span`
   margin-right:2.0rem;
`;

const SumaryProducts = style.div`
   display:flex;
   flex-direction:column;
   margin-top:1.0rem;
   width:100%;
   div{
       display:flex;
       flex-direction:row;
       justify-content:space-around;
       div{
           display:flex;
           flex-direction:column;
           span{
               font-size:${({ theme }) => theme.fontSizes.small};
               margin:0.4rem;
           }
       }
   }
`;

export default function ConfirmOrder() {

    const {delivery,cartItems,TotalPrice} = useSelector(state=>state.order)
    
    return (
        <Container width={"auto"} type={"column"} justify={"center"} display={"grid"}>
            <Body>
                <Title>Order</Title>
                <Info>
                       <span>
                          <Span>Price</Span>
                          <Format price={TotalPrice}/></span>
                          <span><Span>Name</Span><Span>{delivery.fullName}</Span></span>
                      <span><Span>Zip/Code</Span><Span>{delivery.postalCode}</Span></span>
                      <span><Span>Address</Span><Span>{delivery.address}</Span></span>
                </Info>
                {cartItems.map(cartItems =>(
                          <SumaryProducts key={cartItems.id}>
                              <div>
                              <img alt="cart-img" src={cartItems.image} style={{height:"50px",width:"50px"}} />
                              <div>
                              <span>{cartItems.title}</span>
                              <span>preço:<Format price={cartItems.price}/></span>
                              </div>
                              </div>
                          </SumaryProducts>
                      ))}
            </Body>
        </Container>
    )
}
